import { Component, ChangeDetectionStrategy, input, computed, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'widget-iframe',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (yukleniyor()) {
      <div class="spinner-kapsul" [style.height]="yukseklik()">
        <div class="spinner"></div>
      </div>
    }
    @if (guvenliUrl()) {
      <iframe
        [src]="guvenliUrl()"
        [sandbox]="sandbox()"
        [style.height]="yukseklik()"
        [class.kenarlikli]="kenarlik()"
        [class.gizli]="yukleniyor()"
        (load)="yukleniyor.set(false)"
      ></iframe>
    }
  `,
  styles: [`
    :host { display: block; border-radius: 8px; overflow: hidden; position: relative; }
    iframe {
      display: block; width: 100%; border: none; border-radius: 8px;
      background: var(--py-arkaplan, #fff);
    }
    iframe.kenarlikli { border: 1px solid var(--py-sinir, #d9d9d9); }
    iframe.gizli { visibility: hidden; position: absolute; }
    .spinner-kapsul {
      display: flex; align-items: center; justify-content: center;
      background: var(--py-hover, rgba(0,0,0,0.02)); border-radius: 8px;
    }
    .spinner {
      width: 28px; height: 28px; border-radius: 50%;
      border: 3px solid var(--py-sinir, #d9d9d9);
      border-top-color: #1890ff;
      animation: don 0.8s linear infinite;
    }
    @keyframes don { to { transform: rotate(360deg); } }
  `],
})
export class IframeComponent {
  private sanitizer = inject(DomSanitizer);

  url = input('');
  yukseklik = input('100%');
  sandbox = input('allow-scripts allow-same-origin');
  kenarlik = input(false);

  yukleniyor = signal(false);

  guvenliUrl = computed(() => {
    const u = this.url();
    if (!u) return null;
    this.yukleniyor.set(true);
    return this.sanitizer.bypassSecurityTrustResourceUrl(u);
  });
}
